// constants
import { showSuccessAlert } from "../../constants/alerts";
import { MainBannerActionTypes } from "./constants";

const INIT_STATE = {
  mainBanner: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface MainBannerData {
  id: number;
  head: string;
  head_ar: string;
  subhead: string;
  subhead_ar: string;
  title_text: string;
  title_text_ar: string;
  file: any;
}

interface MainBannerActionType {
  type:
    | MainBannerActionTypes.API_RESPONSE_SUCCESS
    | MainBannerActionTypes.API_RESPONSE_ERROR
    | MainBannerActionTypes.CREATE_MAIN_BANNER
    | MainBannerActionTypes.GET_MAIN_BANNER
    | MainBannerActionTypes.UPDATE_MAIN_BANNER
    | MainBannerActionTypes.DELETE_MAIN_BANNER;
  payload: {
    actionType?: string;
    data?: any | {};
    error?: string;
    mainBanner?: [];
  };
}

interface State {
  mainBanner?: MainBannerData | [];
  loading?: boolean;
  value?: boolean;
}

const MainBanner = (
  state: any = INIT_STATE,
  action: MainBannerActionType
): any => {
  switch (action.type) {
    case MainBannerActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case MainBannerActionTypes.CREATE_MAIN_BANNER: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case MainBannerActionTypes.GET_MAIN_BANNER: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            mainBanner: action.payload.data,
          };
        }
        case MainBannerActionTypes.UPDATE_MAIN_BANNER: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case MainBannerActionTypes.DELETE_MAIN_BANNER: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        default:
          return { ...state };
      }

    case MainBannerActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case MainBannerActionTypes.CREATE_MAIN_BANNER: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case MainBannerActionTypes.UPDATE_MAIN_BANNER: {
          return {
            ...state,
            loading: false,
            error: action.payload.error,
          };
        }
        case MainBannerActionTypes.GET_MAIN_BANNER: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case MainBannerActionTypes.DELETE_MAIN_BANNER: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        default:
          return { ...state };
      }

    case MainBannerActionTypes.CREATE_MAIN_BANNER:
      return { ...state, loading: true };
    case MainBannerActionTypes.UPDATE_MAIN_BANNER:
      return { ...state, loading: true };
    case MainBannerActionTypes.GET_MAIN_BANNER:
      return { ...state, loading: true, initialLoading: true };
    case MainBannerActionTypes.DELETE_MAIN_BANNER:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default MainBanner;
